(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('ReceiptFile', ReceiptFile);

  ReceiptFile.$inject = ['$resource', 'API_URI'];

  function ReceiptFile($resource, API_URI) {
    var resourceUrl = API_URI + 'api/receipt-files/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
